// extracted by mini-css-extract-plugin
export default {"reliable":"Reliable_reliable__vQg4p","container":"Reliable_container__Z3jvs","content":"Reliable_content__0BbY9","title":"Reliable_title__VUdj3"};